import styled from '@emotion/styled';
import { MOBILE_BREAKPOINT } from 'hooks/useIsMobile/useIsMobile';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: fixed;
  inset: 0;

  gap: 16px;
  overflow: auto;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 16px;

    > img {
      width: 80%;
      max-width: 400px;
    }
  }

  @media (max-height: 480px) {
    justify-content: initial;
    padding: 16px;
  }
`;
